import React from "react";
import { styles } from "@/config/project";
import { Info } from "@mui/icons-material";
import { ExpandableWidget } from "./ExpandableWidget";

interface GuidanceExpandableWidgetProps {
    title?: string;
    guidance: string;
    attribution?: string;
    defaultExpanded?: boolean;
    noWrapper?: boolean;
}

export const GuidanceExpandableWidget: React.FC<
    GuidanceExpandableWidgetProps
> = ({
    title = "Guidance",
    guidance,
    attribution,
    defaultExpanded = false,
    noWrapper = true,
}) => {
    return (
        <ExpandableWidget
            icon={<Info />}
            title={title}
            attribution={attribution}
            accentColor={styles.warningColor}
            backgroundColor={styles.warningLight}
            textColor={styles.warningDark}
            defaultExpanded={defaultExpanded}
            noWrapper={noWrapper}
            wrapUnbrokenText
        >
            {guidance}
        </ExpandableWidget>
    );
};

// Keep the old export name for backwards compatibility
export const ExpandableGuidance = GuidanceExpandableWidget;
